import {
  collection,
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from 'firebase/firestore';
import { firestore } from '@/lib/firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useMemo } from 'react';

type TaskExecution = {
  stderr: string;
  stdout: string;
  imageUri: string;
  logUri?: string;
  ip: string;
};

const taskExecutionConverter: FirestoreDataConverter<TaskExecution> = {
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): TaskExecution {
    const data = snapshot.data(options);
    return {
      ...data,
      ip: snapshot.id,
    } as TaskExecution;
  },
  toFirestore: function (): WithFieldValue<DocumentData> {
    throw new Error('Function not implemented.');
  },
};

export function useTaskExecutions(id?: string) {
  // Guard: an empty id would make collection() throw on the invalid path
  // 'task//execution', which would crash the page.
  const ref = useMemo(
    () =>
      id
        ? collection(firestore, `task/${id}/execution`).withConverter(
            taskExecutionConverter
          )
        : undefined,
    [id]
  );
  return useCollectionData(ref, {
    snapshotListenOptions: { includeMetadataChanges: false },
  });
}
